// skills re-formated data
export function remapJSON(remappedJSON: any, progressDetails: any, userskillscourseslist: any, avoidMerging: boolean) {
  let newRemappedJSON: any = {};
  newRemappedJSON.skilltitle = progressDetails.skill_name;
  newRemappedJSON.userid = progressDetails.user_id;
  newRemappedJSON.username = "";
  newRemappedJSON.skilllevel = progressDetails.level;
  newRemappedJSON.skillcourses = [];
  let course: any = {};
  progressDetails.skill_courses.map((unit: any) => {
    if (unit.skill_name) {
      course = {};
      course.subskillid = unit.sub_skill_id;
      course.usertestscore = unit.user_test_score ? unit.user_test_score : 0;
      course.maxtestscore = unit.max_test_score ? unit.max_test_score : 0;
      course.subskilltitle = unit.sub_skill_name;
      course.courseparttitle = unit.course_part_title;
      course.skilltypeid = unit.sub_skill_type;
      course.totalprework = unit.total_prework;
      course.preworkcompleted = unit.prework_completed;
      course.totalhomework = unit.total_homework ? unit.total_homework : 0;
      course.homeworkcompleted = unit.homework_completed;
      course.totalsession = unit.total_session ? unit.total_session : 0;
      course.sessioncompleted = unit.session_completed ? unit.session_completed : 0;
      course.sessionstatus = unit.session_status ? unit.session_status : 0;
      course.sessionCompletedDate = unit.session_completed_date;
      newRemappedJSON.skillcourses.push(course);
    }
  });
  if (avoidMerging) return newRemappedJSON;
  userskillscourseslist.data.userskillscourseslist.push(newRemappedJSON);

  // return data
  return userskillscourseslist;
}

export const separateIndivUnitCountBasedOnLevel = (allCompletedListUnitbefore: any) => {
  let structuredArr: any = [];
  let levelsList: any = [];
  if (allCompletedListUnitbefore && allCompletedListUnitbefore.length > 0) {
    allCompletedListUnitbefore.map((datum: any) => {
      if (levelsList.indexOf(datum.level) === -1) {
        let singleDataObj: any = {
          level: datum.level,
          prework: 0,
          totalprework: 0,
          sessions: 0,
          totalsessions: 0,
          units: [],
        };
        singleDataObj.units.push(datum);
        structuredArr.push(singleDataObj);
        levelsList.push(datum.level);
      } else {
        for (let i = 0; i < structuredArr.length; i++) {
          if (structuredArr[i].level === datum.level) {
            structuredArr[i].units.push(datum || {});
          }
        }
      }
    });
  }
  return structuredArr;
};
